import { DateTime } from 'luxon'
import { Instance, types } from 'mobx-state-tree'

export const UserSubscription = types
  .model('UserSubscription')
  .props({
    id: types.identifierNumber,
    purchase_id: types.number,
    title: types.string,
    description: types.maybeNull(types.string),
    color: types.maybe(types.maybeNull(types.string)),
    content: types.array(types.frozen()),
    purchased_date: types.optional(types.string, ''),
    expiration_date: types.maybeNull(types.string),
    transaction_type: types.string,
  })
  .views((self) => ({
    get isActive() {
      if (!self.expiration_date) return true
      return DateTime.fromISO(self.expiration_date) > DateTime.now()
    },
    get isExpired() {
      if (!self.expiration_date) return false
      return DateTime.fromISO(self.expiration_date) < DateTime.now()
    },
    get isExpiring() {
      if (!self.expiration_date) return false
      const expiration = DateTime.fromISO(self.expiration_date)
      const now = DateTime.now()
      return expiration > now && expiration <= now.plus({ days: 7 })
    },
    get status() {
      if (this.isExpired) {
        return 'expired'
      } else if (this.isExpiring) {
        return 'expiring'
      } else {
        return 'active'
      }
    },
  }))

export type UserSubscriptionType = Instance<typeof UserSubscription>
